import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import Button from "components/Elements/Button/Button.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import "./AddSubUserModal.scss";
import { useProfile } from "contexts/profileContext/profileContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import InputElement from "components/Elements/InputElement/InputElement.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import parse from "html-react-parser";
import config from "config";

const vIcon = `${config.api.resource}/assets/images/plans/v-icon.svg`;

const AddSubUserInvitationLink = ({ setLoading, setIsInvitationLink }) => {
  const { getTextByKey, getLanguageCulture } = useContent();

  const { getUserData } = useUser();
  const userDomain = `@${getUserData().UserName.split("@")[1]}`;
  const [errorMessage, setErrorMessage] = useState({});
  const { getSubUserData } = useProfile();
  const [icon, setIcon] = useState("loading");
  const [link, setLink] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const textAreaRef = useRef(null);

  useEffect(() => {
    ValidateEmailDomain();
  }, []);

  useEffect(() => {
    let element = document.getElementsByClassName("invite-by-email-span-link");
    if (element !== null && element !== undefined && element.length > 0) {
      element[0].addEventListener(
        "click",
        () => setIsInvitationLink(false),
        false
      );
    }
  });

  const ValidateEmailDomain = async () => {
    const domain = `@${getUserData().UserName.split("@")[1]}`;
    const response = await apiRequest(
      "SubUsers",
      `ReactSetInvitationLink?&domain=${domain}&isAdminSubUser=${
        getUserData().IsAdminSubUser || false
      }`,
      null,
      "POST"
    );
    if (response.status === "success") {
      setErrorMessage("");
      setIcon("v-icon");
      setLink(
        `${config.baseurl}/${getLanguageCulture().substring(0, 2)}/invite/${
          response.data
        }`
      );
    } else {
      if (response.data === "domain-is-blocked") {
        setErrorMessage({
          isShow: true,
          errorText: parse(getTextByKey(response.data)),
        });
        setIcon("error-info");
      } else if (response.data.includes("domain-exists")) {
        const userEmail = response.data.split("user:")[1];
        const domainExistsMessage = getTextByKey("domain-exists").replace(
          "#UserEmail#",
          userEmail
        );
        setErrorMessage({ isShow: true, errorText: domainExistsMessage });
        setIcon("error-info");
      } else {
        setErrorMessage({ isShow: true, errorText: "error-occurred" });
      }
    }
    setLoading(false);
  };

  const getIcon = () => {
    switch (icon) {
      case "loading":
        return <Icon icon="loading" className="loading-icon" />;
      case "v-icon":
        return <Icon src={vIcon} blue large />;
      case "error-info":
        return <Icon name={"error-info"} red large />;
      default:
        return null;
    }
  };

  const copyTextAreaToClibord = () => {
    textAreaRef.current.select();

    document.execCommand("copy");
    setIsCopied(true);
  };

  return (
    <>
      {
        <div className="insert-new-user-invitation">
          <div
            className={`domain-input ${
              getLanguageCulture().includes("he")
                ? "domain-input-ltr"
                : "domain-input-rtl"
            }`}
          >
            <InputElement
              isColumn={true}
              inputLabel={"add-sub-user-domain"}
              placeholder={"new-domain-title-place-holder"}
              state={userDomain}
              specificClass={"sub-user-domain-label"}
              errorObject={errorMessage}
              disabled={true}
              icon={getIcon()}
            />
          </div>
          {link && (
            <div className="invitation-link">
              <div className="input-element-label">
                {getTextByKey("invitation-link-label")}
              </div>
              <div className="invitation-link-input">
                <input
                  type="text"
                  readOnly
                  ref={textAreaRef}
                  value={link}
                  // if hebrew put ltr class
                  className={`invitation-link-input-text ${
                    getLanguageCulture().includes("he") ? "ltr" : ""
                  }`}
                ></input>
                <div
                  className="copy-icon"
                  onClick={() => copyTextAreaToClibord()}
                >
                  {isCopied && (
                    <span
                      className={`text ${
                        getLanguageCulture().includes("he") ? "ltr" : ""
                      }`}
                    >
                      {getTextByKey("copied-text")}
                    </span>
                  )}
                  <Icon title="" name="copy-b" blue={isCopied} />
                </div>
              </div>
            </div>
          )}
        </div>
      }
    </>
  );
};

export default AddSubUserInvitationLink;
